import React from 'react'
import { Bell, Search, Menu } from 'lucide-react'
import { useAuth } from '../../context/AuthContext'
import Button from '../ui/Button'
import SearchInput from '../ui/SearchInput'
import NotificacoesDropdown from './NotificacoesDropdown'

interface HeaderProps {
  onSidebarToggle: () => void
}

const Header: React.FC<HeaderProps> = ({ onSidebarToggle }) => {
  const { user } = useAuth()

  const handleGlobalSearch = async (term: string) => {
    // TODO: Implementar busca global
    return []
  }

  const handleSearchSelect = (result: any) => {
    // TODO: Implementar navegação baseada no resultado
    console.log('Selected:', result)
  }

  return (
    <header className="bg-white border-b border-gray-200">
      <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8">
        {/* Left section */}
        <div className="flex items-center space-x-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={onSidebarToggle}
            className="lg:hidden"
          >
            <Menu className="h-5 w-5" />
          </Button>

          {/* Global search */}
          <div className="hidden md:block w-96">
            <SearchInput
              placeholder="Pesquisar clientes, equipamentos, OS..."
              onSearch={handleGlobalSearch}
              onSelect={handleSearchSelect}
              emptyMessage="Nenhum resultado encontrado"
            />
          </div>
        </div>

        {/* Right section */}
        <div className="flex items-center space-x-4">
          {/* Mobile search button */}
          <Button
            variant="ghost"
            size="sm"
            className="md:hidden"
          >
            <Search className="h-5 w-5" />
          </Button>

          {/* Notifications */}
          <NotificacoesDropdown />

          {/* User info */}
          {user && (
            <div className="hidden sm:flex items-center space-x-3">
              <div className="text-right">
                <p className="text-sm font-medium text-gray-900">{user.nome}</p>
                <p className="text-xs text-gray-500">
                  {user.tipo.charAt(0) + user.tipo.slice(1).toLowerCase()}
                </p>
              </div>
              <div className="w-8 h-8 bg-primary-600 rounded-full flex items-center justify-center">
                <span className="text-sm font-medium text-white">
                  {user.nome.charAt(0).toUpperCase()}
                </span>
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  )
}

export default Header